import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const NavigationOffCanvas = ({ open, handleToggle, children }) => {
  return (
    <div className="NavigationOffCanvas">
      <div
        className={classNames('NavigationOffCanvas__overlay', {
          'NavigationOffCanvas__overlay-open': open,
        })}
        onClick={handleToggle}
      />
      <div
        className={classNames('NavigationOffCanvas__content', {
          'NavigationOffCanvas__content-open': open,
        })}
      >
        {children}
      </div>
    </div>
  );
};

NavigationOffCanvas.propTypes = {
  open: PropTypes.bool.isRequired,
  handleToggle: PropTypes.func.isRequired,
};

export default observer(NavigationOffCanvas);
